import React from "react";

import FormiLogoFull from "../components/FormiLogoFull";
import GenericButton from "../components/GenericButton";
import "../styles/landing.scss";

function LaunchedLanding() {
  return (
    <section id="homeHero">
      <article className="content">
        <FormiLogoFull />
        <h2>A community by us for you</h2>
        <GenericButton text="Join Us" href="/join-community" />
      </article>
    </section>
  );
}

export default LaunchedLanding;
